var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[(_vm.type == 1)?_c('NetWorkChartWindow'):_vm._e(),(_vm.type == 2)?_c('CompanyRiskLookup'):_vm._e()],1),_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }